import { create } from 'zustand';

export type Notification = {
  id: string;
  message: string;
  code: number | undefined;
  description: string;
  type: 'success' | 'error' | 'info' | 'warning';
};

export type NotificationStore = {
  notifications: Notification[];
  addNotification: (notification: Notification) => void;
  removeNotification: (id: string) => void;
};

export const useNotifixationStore = create<NotificationStore>((set) => ({
  notifications: [] as Notification[],

  addNotification: (notification: Notification) => {
    if (notification.code == 401) {
      localStorage.removeItem('token');
      notification.message = 'Your token has expired. Please login again.';
    }
    set((state) => ({ notifications: [...state.notifications, notification] }));
  },
  removeNotification: (id: string) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    })),
}));
